//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import mdAutocomplete from '../../../../../shared-components/autocomplete/mdAutocomplete';
import InputMoneyOld from '../../../../../shared-components/InputMoneyOld';
import { prepareResponseData } from '../../../../../common/functions/http';

export default {
  name: 'TransferenciaDesdobramento',
  props: {
    somenteLeitura: Boolean,
    idDesdobramento: Number,
    idRepresentante: Number,
    idOrcamentoOrigem: Number,
    idDesdobramentoOrigem: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      fetchOrcamentoFunction: this.$api.orcamento(this.$resource).listarAprovados,
      fetchLinhaFunction: this.$api.linhasInvestimento(this.$resource).buscarPorOrcamento,
      orcamentoResource: this.$api.orcamento(this.$resource),
      desdobramentoResource: this.$api.desdobramento(this.$resource),
      representanteResource: this.$api.representante(this.$resource),
      disableLinha: true,
      disableDesdobramento: true,
      disableRepresentante: true,
      desdobramento: {
        idOrcamento: null,
        descricaoOrcamento: '',
        idLinhaInvestimento: null,
        descricaoLinha: '',
        idDesdobramento: null,
        competencia: '',
        idRepresentante: null,
        representante: '',
        vlrPlanejado: 0,
        vlrDisponivel: 0,
      },
    };
  },
  watch: {
    idDesdobramentoOrigem() {
      this.limparOrcamento();
      this.desdobramento.descricaoOrcamento = '';
    },
  },
  methods: {
    setOrcamento(hit) {
      if (!hit.id) {
        this.limparOrcamento();
        return;
      }
      this.disableLinha = false;
      this.desdobramento.idOrcamento = hit.id;
      this.desdobramento.descricaoOrcamento = hit.descricao;
      this.desdobramento.descricaoLinha = '';
      if (!this.idOrcamentoOrigem) {
        this.$emit('TRANSFERENCIAORCAMENTO_SET', hit.id);
      }
      this.limparLinha();
    },
    setLinha(hit) {
      if (!hit.id) {
        this.limparLinha();
        return;
      }
      this.disableDesdobramento = false;
      this.desdobramento.idLinhaInvestimento = hit.id;
      this.desdobramento.descricaoLinha = hit.descricao.trim();
      this.desdobramento.competencia = '';
      this.limparDesdobramento();
    },
    setDesdobramento(hit) {
      if (!hit.id) {
        this.limparDesdobramento();
        return;
      }
      this.disableRepresentante = false;
      this.desdobramento.idDesdobramento = hit.id;
      this.desdobramento.competencia = hit.anoMes;
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET', hit.id);
      this.desdobramento.representante = '';
      this.limparRepresentante();
    },
    setRepresentante(hit) {
      if (!hit.idRepresentante) {
        this.limparRepresentante();
        return;
      }
      this.desdobramento.idRepresentante = hit.idRepresentante;
      this.desdobramento.representante = hit.nome;
      this.buscarValoresRepresentante();
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET_REPRESENTANTE', hit.idControladorTrade);
    },
    buscarLinha(row) {
      row.codigo = this.desdobramento.idOrcamento;
      return this.fetchLinhaFunction(row);
    },
    buscarDesdobramento(row) {
      if (this.idDesdobramentoOrigem) {
        return this.desdobramentoResource.buscarDestinoVigentesPorLinhaInvestimento(
          { codigo: this.desdobramento.idLinhaInvestimento,
            anoMes: row.anoMes,
            idDesdobramentoOrigem: this.idDesdobramentoOrigem });
      }
      return this.desdobramentoResource.buscarVigentesPorLinhaInvestimentoTransferencia(
        { codigo: this.desdobramento.idLinhaInvestimento, anoMes: row.anoMes });
    },
    buscarOrcamentos(row) {
      if (this.idOrcamentoOrigem) {
        return this.orcamentoResource.listarDestinoAprovados(
          { descricao: row.descricao,
            idOrcamentoOrigem: this.idOrcamentoOrigem });
      }
      return this.orcamentoResource.listarAprovados(
        { descricao: row.descricao });
    },
    buscarRepresentante(row) {
      row.codigo = this.desdobramento.idDesdobramento;
      return this.desdobramentoResource.buscarRepresentantes(row);
    },
    buscarValores() {
      return this.desdobramentoResource.buscarPlanejadoDisponivel(
        { codigo: this.desdobramento.idDesdobramento })
        .then(this.preencherValores)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarValoresRepresentante() {
      return this.desdobramentoResource.buscarPlanejadoDisponivelRepresentante(
        { codigo: this.desdobramento.idDesdobramento,
          idRepresentante: this.desdobramento.idRepresentante })
        .then(this.preencherValores)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    preencherValores(response) {
      this.desdobramento.vlrPlanejado = response.data.vlrPlanejado;
      this.desdobramento.vlrDisponivel = response.data.vlrDisponivel;
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET_VALORES', response.data.vlrDisponivel);
    },
    limparOrcamento() {
      this.desdobramento.idOrcamento = null;
      this.desdobramento.descricaoLinha = '';
      this.disableLinha = true;
      if (!this.idOrcamentoOrigem) {
        this.$emit('TRANSFERENCIAORCAMENTO_SET');
      }
      this.limparLinha();
    },
    limparLinha() {
      this.desdobramento.idLinhaInvestimento = null;
      this.desdobramento.competencia = '';
      this.disableDesdobramento = true;
      this.limparDesdobramento();
    },
    limparDesdobramento() {
      this.disableRepresentante = true;
      this.desdobramento.idDesdobramento = null;
      this.desdobramento.representante = '';
      this.desdobramento.vlrPlanejado = 0;
      this.desdobramento.vlrDisponivel = 0;
      this.desdobramento.idRepresentante = null;
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET');
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET_VALORES', this.desdobramento.vlrDisponivel);
    },
    limparRepresentante() {
      this.desdobramento.idRepresentante = null;
      if (this.desdobramento.idDesdobramento) this.buscarValores();
      this.$emit('TRANSFERENCIADESDOBRAMENTO_SET_REPRESENTANTE');
    },
    carregarValores() {
      if (this.desdobramento.idRepresentante) {
        this.buscarValoresRepresentante();
        return;
      }
      this.buscarValores();
    },
    carregarRepresentante() {
      if (this.idRepresentante) {
        this.representanteResource.obter({ id: this.idRepresentante })
          .then((response) => {
            this.desdobramento.representante = response.data.nome;
          })
          .catch(err => this.$error(this, err));
      }
    },
    carregarDesdobramento() {
      this.desdobramento.idDesdobramento = this.idDesdobramento;
      this.desdobramento.idRepresentante = this.idRepresentante;
      this.desdobramentoResource.buscarHierarquia({ codigo: this.idDesdobramento })
        .then((response) => {
          this.preencherDesdobramento(response.data);
        })
        .then(this.carregarRepresentante)
        .then(this.carregarValores)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    preencherDesdobramento(data) {
      this.desdobramento.idDesdobramento = data.id;
      this.desdobramento.competencia = data.competencia;
      this.desdobramento.descricaoLinha = data.descricaoLinha;
      this.desdobramento.descricaoOrcamento = data.descricaoOrcamento;
      this.desdobramento.idLinhaInvestimento = data.idLinhaInvestimento;
      this.desdobramento.idOrcamento = data.idOrcamento;
    },
    prepareResponseData,
  },
  beforeMount() {
    if (this.idDesdobramento) {
      this.carregarDesdobramento();
    }
  },
  components: {
    mdAutocomplete,
    InputMoneyOld,
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/orcamento/transferencia/TransferenciaDesdobramento.vue?vue&type=script&lang=js&